import React, { useEffect, useState } from "react";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { wordsByMonth } from "./data/words";
import MonthSelector from "./components/MonthSelector";
import GameScreen from "./components/GameScreen";
import EndScreen from "./components/EndScreen";

function App() {
	const [selectedMonth, setSelectedMonth] = useState("");
	const [isGameStarted, setIsGameStarted] = useState(false);
	const [score, setScore] = useState(100);
	const [finalScore, setFinalScore] = useState(null);

	const startGame = () => {
		setIsGameStarted(true);
		setScore(100);
	};

	const endGame = (calculatedScore) => {
		setFinalScore(calculatedScore);
		setIsGameStarted(false);
	};

	const playAgain = () => {
		setFinalScore(null);
		setSelectedMonth("");
		setScore(100);
	};

	const restartGame = () => {
		setIsGameStarted(false);
		setSelectedMonth("");
		setScore(100);
		setFinalScore(null);
	};

	useEffect(() => {
		const html = document.documentElement;
		const body = document.body;

		if (isGameStarted) {
			html.style.overflow = "hidden";
			body.style.overflow = "hidden";
			html.style.overscrollBehavior = "none";
			body.style.overscrollBehavior = "none";
			body.style.touchAction = "none";
		} else {
			html.style.overflow = "";
			body.style.overflow = "";
			html.style.overscrollBehavior = "";
			body.style.overscrollBehavior = "";
			body.style.touchAction = "";
		}

		return () => {
			html.style.overflow = "";
			body.style.overflow = "";
			html.style.overscrollBehavior = "";
			body.style.overscrollBehavior = "";
			body.style.touchAction = "";
		};
	}, [isGameStarted]);

	return (
		<DndProvider
			backend={TouchBackend}
			options={{
				enableMouseEvents: true,
				delayTouchStart: 0,
				delayMouseStart: 0,
				touchSlop: 0,
				ignoreContextMenu: true,
			}}
		>
			<div
				className="flex flex-col min-h-screen bg-cover bg-center relative"
				style={{
					backgroundImage: `url(${process.env.PUBLIC_URL}/bg.webp)`,
				}}
			>
				<div className="flex-1 flex flex-col items-center justify-center">
					{!isGameStarted && finalScore === null && (
						<MonthSelector
							selectedMonth={selectedMonth}
							setSelectedMonth={setSelectedMonth}
							startGame={startGame}
						/>
					)}

					{isGameStarted && (
						<GameScreen
							words={wordsByMonth[selectedMonth]}
							initialScore={score}
							endGame={endGame}
							restartGame={restartGame}
						/>
					)}

					{finalScore !== null && (
						<EndScreen
							finalScore={finalScore}
							playAgain={playAgain}
						/>
					)}
				</div>

				<footer className="fixed bottom-0 left-0 w-full p-2 text-center">
					<p>
						Game developed by{" "}
						<a href="https://ceci.jp">
							<span className="underline text-blue-500 font-medium">
								CECI Educational Academy
							</span>
						</a>
					</p>
				</footer>
			</div>
		</DndProvider>
	);
}

export default App;
